import { isUndefined } from 'shared-utils'
import { type KustomCheckoutEventsHandlers } from './types'

export const suspendKlarnaCheckoutWidget = (autoResume = false) => {
  // @ts-expect-error -- need
  window?._klarnaCheckout?.((api) => {
    api.suspend(
      !isUndefined(autoResume) && {
        autoResume: {
          enabled: autoResume
        }
      }
    )
  })
}

export const resumeKlarnaCheckoutWidget = () => {
  // @ts-expect-error -- need
  window?._klarnaCheckout?.((api) => {
    api.resume()
  })
}

export const subscribeToKlarnaCheckoutEvents = (handlers: KustomCheckoutEventsHandlers) => {
  // @ts-expect-error -- need
  window?._klarnaCheckout?.((api) => {
    if (!api) {
      return
    }

    api.on(handlers)
  })
}
